// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2KKYD","messages":"Chat_messages__KfIwC","dateDivider":"Chat_dateDivider__1yj5B"};